"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsorFooter = exports.CopyrightFooter = exports.Footer = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const I18n_1 = require("../../../i18n/I18n");
function Footer(_a) {
    var { sponsor = true } = _a, props = tslib_1.__rest(_a, ["sponsor"]);
    return (jsx_runtime_1.jsxs("footer", { children: [jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx(CopyrightFooter, Object.assign({}, props), void 0) }, void 0),
            sponsor && (jsx_runtime_1.jsx("div", { children: jsx_runtime_1.jsx(exports.SponsorFooter, {}, void 0) }, void 0))] }, void 0));
}
exports.Footer = Footer;
function CopyrightFooter({ brand, }) {
    const { t } = I18n_1.useTranslation();
    const currentYear = new Date().getFullYear();
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [t("Copyright"), " \u00A9 ", currentYear, " ", brand] }, void 0));
}
exports.CopyrightFooter = CopyrightFooter;
const SponsorFooter = () => {
    const { t } = I18n_1.useTranslation();
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs("span", Object.assign({ title: t("Powered by") }, { children: [t("⚡ by"), " "] }), void 0),
            jsx_runtime_1.jsx("a", Object.assign({ href: "https://reactionable.github.io/reactionable/", rel: "noreferrer", target: "_blank", title: t("Reactionable - An effective toolkit for React") }, { children: "Reactionable" }), void 0)] }, void 0));
};
exports.SponsorFooter = SponsorFooter;
//# sourceMappingURL=Footer.js.map